import React from "react";
import { CartItem } from "../components";

export const cartBoxes = (items) => {
  return Object.keys(items)
    .reverse()
    .map(c => {
      let item = items[c];
      return <CartItem key={item.jmId} {...item} />;
    });
};
